<template>
  <BaseUpsell
    :dismissible="false"
    :inlineIcon="true"
  >
    <template v-slot:icon>
      <TeamsCircleIcon
        v-if="hasTried"
        :showPadlock="true"
        class="flex-shrink-0 self-start mb-base w-fifty"
        data-test='teams-locked-icon'
      />
    </template>
    <template v-slot:title>
      <p
        class="text-black font-bold text-2xl"
        data-test="teams-card-title"
      >
        {{ $t(hasTried ? 'upsells.teams.lockedTitle' : 'upsells.teams.title') }}
      </p>
    </template>
    <template v-slot:explainer>
      <div class="flex flex-col lg:flex-row justify-between items-center">
        <p
          class="w-full text-base text-black"
        >
          {{ $t(hasTried ? 'upsells.teams.lockedExplainer' : 'upsells.teams.explainer') }}
        </p>
        <div
          v-if="canUpgrade"
          class="w-full flex flex-col md:flex-row lg:justify-end md:mt-auto lg:my-auto"
        >
          <ButtonLink
            :to="{ name: 'Billing', hash: '#plans' }"
            variant="primaryDark"
            class="order-1 md:order-2 md:ml-5 mb-5 md:mb-0"
            data-test="upgrade-button"
          >
            {{ $t('upsells.ctaTitle') }}
          </ButtonLink>
          <ButtonLink
            to="https://www.signable.co.uk/users-teams/"
            target="_blank"
            variant="secondaryDark"
            class="order-2 md:order-1"
            data-test="learn-more-button"
          >
            {{ $t('upsells.ctaSecondaryTitle') }}
          </ButtonLink>
        </div>
      </div>
    </template>
    <template v-slot:cta>
      <p
        v-if="!canUpgrade"
        class="text-black font-bold mt-6"
        data-test="teams-contact-admin-message"
      >
        {{ $t('upsells.contactAdminMessage') }}
        <BaseLink
          variant="invisible"
          size="none"
          href="https://www.signable.co.uk/plans/"
          target="_blank"
          class="font-normal"
          data-test="teams-learn-more-message"
        >
          {{ $t('upsells.learnMoreMessage') }}
        </BaseLink>
      </p>
    </template>
  </BaseUpsell>
</template>

<script>
import { BaseUpsell } from '@/components/library/upsells';
import { TeamsCircleIcon } from '@/components/icons';
import ButtonLink from '@/components/library/links/ButtonLink.vue';
import BaseLink from '@/components/library/links/BaseLink.vue';

export default {
  name: 'TeamsUpsell',
  components: {
    BaseUpsell,
    TeamsCircleIcon,
    ButtonLink,
    BaseLink,
  },
  props: {
    canUpgrade: {
      type: Boolean,
      required: true,
    },
    hasTried: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
